namespace RedBullMOBILE360.CVM {

    @Serenity.Decorators.registerClass('RedBullMOBILE360.CVM.CriteriaConditionGrid')
    export class CriteriaConditionGrid extends Serenity.EntityGrid<CriteriaConditionRow, any> {
        protected getColumnsKey() { return CriteriaConditionColumns.columnsKey; }
        protected getDialogType() { return CriteriaConditionDialog; }
        protected getIdProperty() { return CriteriaConditionRow.idProperty; }
        protected getInsertPermission() { return CriteriaConditionRow.insertPermission; }
        protected getLocalTextPrefix() { return CriteriaConditionRow.localTextPrefix; }
        protected getService() { return CriteriaConditionService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}